import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import type { Node } from './../../ricos-schema/legacy/wix/rich_content/v1';
import { Node_Type, type NodeViewRendererProps } from './../../ricos-types';

import classes from './viewer-figure.rtlignore-scss';

export const ViewerFigure: FC<NodeViewRendererProps & PropsWithChildren> = ({
  node,
  nodeIndex,
  NodeViewContainer,
  RicosNodesRenderer,
  children,
}) => {
  const nodes: Node[] =
    node.imageData?.caption && !node.nodes?.length
      ? [
          {
            type: Node_Type.CAPTION,
            id: `${node.id ?? ''}-caption`,
            nodes: [
              {
                type: Node_Type.TEXT,
                id: '',
                nodes: [],
                textData: {
                  text: node.imageData.caption,
                  decorations: [],
                },
              },
            ],
          },
        ]
      : node.nodes ?? [];

  return (
    <NodeViewContainer node={node} nodeIndex={nodeIndex}>
      {({ ContainerElement, SpoilerWrapper, LinkWrapper }) => {
        return (
          <ContainerElement>
            <figure className={classes.figure} data-hook={`figure-${node.type}`}>
              <LinkWrapper>
                <SpoilerWrapper>{children}</SpoilerWrapper>
              </LinkWrapper>
              <RicosNodesRenderer nodes={nodes} />
            </figure>
          </ContainerElement>
        );
      }}
    </NodeViewContainer>
  );
};
